import { render, staticRenderFns } from "./UnitsField.vue?vue&type=template&id=a5818582"
import script from "./UnitsField.vue?vue&type=script&lang=js"
export * from "./UnitsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports